
/**
 * MMS: Sticky header fixes
 * 1. Prevents Dawn's StickyHeader from hiding on scroll
 * 2. Measures total header height (announcement + nav) and sets CSS variable
 */
(function() {
  'use strict';

  function patchStickyHeader() {
    var stickyEl = document.querySelector('sticky-header');
    if (!stickyEl) return;

    if (stickyEl.getAttribute('data-sticky-type') === 'always') {
      stickyEl.hide = function() {};
      stickyEl.reveal = function() {
        this.header.classList.remove('shopify-section-header-hidden');
        this.header.classList.add('shopify-section-header-sticky');
      };
      stickyEl.reveal();
    }
  }

  function measureHeaderHeight() {
    var headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (!headerGroup) return;

    var totalHeight = headerGroup.offsetHeight;
    var gap = 16; // breathing room
    document.documentElement.style.setProperty(
      '--mms-total-header-height',
      (totalHeight + gap) + 'px'
    );
  }

  function init() {
    patchStickyHeader();
    measureHeaderHeight();
  }

  // Run on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-measure on resize (header height can change)
  window.addEventListener('resize', measureHeaderHeight);

  // Also run after a delay for async elements
  setTimeout(init, 500);
})();
